import { useParams } from 'react-router-dom';
import { useState } from 'react';
import {
  getScheduleAction,
  getScheduleErrorsAction,
  scheduleActions,
  scheduleSelectors,
} from 'features/schedule/redux';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { getScheduleFile } from 'services/api/schedule-configuration';
import { downloadFile } from 'shared/helpers/utils/files/download';
import type { SchedulePageParams } from 'services/navigation';

export const useToolbar = () => {
  const dispatch = useAppDispatch();
  const coloredLessons = useAppSelector(scheduleSelectors.getColoredLessons);
  const editMode = useAppSelector(scheduleSelectors.getEditMode);
  const filters = useAppSelector(scheduleSelectors.getFilters);

  const [resetFiltersModalOpen, setResetFiltersModalOpen] = useState(false);

  const { configurationId, scheduleId } = useParams<SchedulePageParams>();

  const handleToggleColoredLessons = () => {
    dispatch(scheduleActions.setColoredLessons(!coloredLessons));
  };

  const handleDownloadSchedule = () => {
    if (configurationId && scheduleId) {
      getScheduleFile(configurationId, scheduleId).then((blob) => {
        downloadFile(blob, 'расписание.xlsx');
      });
    }
  };

  const handleEnterEditMode = () => {
    const hasFilters = Boolean(
      filters.teacherId ||
        filters.subjectIds?.length ||
        filters.roomIds?.length ||
        filters.educationalClassIds?.length,
    );

    if (hasFilters) {
      setResetFiltersModalOpen(true);
      return;
    }

    dispatch(scheduleActions.enterEditMode());
  };

  const handleConfirmResetFiltersAndEnterEditMode = async () => {
    if (!configurationId || !scheduleId) return;

    dispatch(scheduleActions.setFilters({}));

    await dispatch(
      getScheduleAction({
        curriculumId: configurationId,
        scheduleId,
        filters: {},
      }),
    );

    dispatch(
      getScheduleErrorsAction({
        configurationId,
        scheduleId,
        filters: {},
      }),
    );

    dispatch(scheduleActions.enterEditMode());
    setResetFiltersModalOpen(false);
  };

  const handleCloseResetFiltersModal = () => setResetFiltersModalOpen(false);

  return {
    state: {
      coloredLessons,
      editMode,
      resetFiltersModalOpen,
    },
    methods: {
      handleToggleColoredLessons,
      handleDownloadSchedule,
      handleEnterEditMode,
      handleConfirmResetFiltersAndEnterEditMode,
      handleCloseResetFiltersModal,
    },
  };
};
